// The endpoint queues the submission and returns. The staff app adds the item and resyncs the case
// later, so the new item reaches the ledger on a later load.
export async function submitEstateItem(caseId, submission) {
  const resp = await fetch(`/api/dashboard/case/${caseId}/submission`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(submission),
  });
  if (!resp.ok) {
    const error = new Error(`Estate item submission failed with ${resp.status}`);
    error.status = resp.status;
    throw error;
  }
}
